export var designConsts = {
    spaceBetweenElements: 16,
    spaceBetweenTitleAndDescription: 6,
};
//# sourceMappingURL=designConsts.js.map